export default Object.freeze([
  {
    text: 'Гражданский брак',
    value: '0',
  },
  {
    text: 'Официальный брак',
    value: '1',
  },
  {
    text: 'Не состоял в браке',
    value: '2',
  },
  {
    text: 'В разводе',
    value: '3',
  },
  {
    text: 'Вдовец',
    value: '4',
  },
])
